module.exports = __webpack_public_path__ + "static/img/blogs-rightside.28edeac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/blogs-rightside.jpg
// module id = rjGn
// module chunks = 0